// extracted by mini-css-extract-plugin
module.exports = {"Image":"CircularText_Image__4PAh5","rotate":"CircularText_rotate__1NThD"};